import { z } from "zod";

export const hospitalizationFormSchema = z.object({
  periodStartDate: z
    .date()
    .min(
      new Date("1900-01-01"),
      "Hospitalization date must be greater than or equal to 1900-01-01",
    )
    .max(
      new Date(),
      "Hospitalization date must be less than or equal to today",
    ),
  reasonCode: z.string().min(1, "Reason code is required"),
  reasonDisplay: z.string().min(1, "Reason display is required"),
  reasonSystem: z.string().min(1, "Reason system is required"),
});
